import { SizePalette, SizePaletteSettings } from '@theme/theme';
import { breakpoints } from '@theme/globals/breakpoints';
import type { Dict } from '@theme/theme.d';

export const pxToRem = (px: number, baseFontSize = 16) => {
  return `${px / baseFontSize}rem`;
};

export const getSizes = (settings: SizePaletteSettings): SizePalette => {
  const sizes: SizePalette = {};
  for (let i = settings.min; i <= settings.max; i += settings.steps) {
    sizes[i] = pxToRem(i);
  }
  return sizes;
};

export const directionToDegrees = (direction: string) => {
  switch (direction) {
    case 'top':
      return '0deg';
    case 'right':
      return '90deg';
    case 'bottom':
      return '180deg';
    case 'left':
      return '270deg';
    default:
      return direction;
  }
};

export const convertNumberToSize = <T>(size: number): T => {
  return pxToRem(size) as T;
};

export const convertObjectToSize = <T>(size: object): T => {
  const convertedSizeObject: Dict = {};
  for (const [key, value] of Object.entries(size)) {
    convertedSizeObject[key] = convertPropToSize<T>(value);
  }
  return convertedSizeObject as T;
};

export const convertPropToSize = <T>(size: unknown): T => {
  let finalSize: T;

  switch (typeof size) {
    case 'number':
      finalSize = pxToRem(size) as T;
      break;
    case 'object':
      finalSize = (size !== null ? convertObjectToSize(size) : {}) as T;
      break;
    case 'boolean':
    case 'string':
    case 'undefined':
    default:
      finalSize = size as T;
  }

  return finalSize;
};

export const convertBreakpointToSize = <T>(size: string): T => {
  if (size === '100%') {
    return size as T;
  }
  return pxToRem(breakpoints[size as keyof typeof breakpoints].value) as T;
};

export const convertPropToBreakpointSize = <T>(size: unknown): T => {
  let finalSize: T;

  switch (typeof size) {
    case 'number':
      finalSize = pxToRem(size) as T;
      break;
    case 'object':
      finalSize = (size !== null ? convertObjectToSize(size) : {}) as T;
      break;
    case 'string':
    default:
      finalSize = convertBreakpointToSize(size as string) as T;
  }

  return finalSize;
};
